import React from "react";
import { Box, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import {
  default as DashboardIcon,
} from "assets/SidebarIcon/Dashboard.png";
import useGetAuthUser from "services/hooks/LoggedInUser/useGetAuthUser";
import { getListingAppUrl, goToListingApp } from "utils/listingAppUrl";
import {
  DASHBOARD_PAGE_KEYS,
  hasDashboardPageAccess,
} from "utils/dashboardPageAccess";
import { SidebarStyle } from "styles/sidebar.styles";

const Trolley =
  "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/SidebarIcon/Trolley.png";
const Shop =
  "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/SidebarIcon/Shop.png";
const WishlistIcon =
  "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/SidebarIcon/wishlistIcon.svg";

const SIDEBAR_ACCENT = "#2261a2";

const UnifiedSidebarRoutes = ({ companyTypeData, sendDataToParent }) => {
  const { data: AuthUserData } = useGetAuthUser();

  const sendData = (props) => {
    sendDataToParent(props);
  };

  const superAdmin = AuthUserData?.data?.superAdmin;
  const rightsarray = AuthUserData?.data?.rightsarray;
  const can = (pageKey) =>
    hasDashboardPageAccess(rightsarray, pageKey, superAdmin);

  const RouteArray = [
    can(DASHBOARD_PAGE_KEYS.MARKETPLACE) && {
      id: 0,
      name: "Home",
      iconComponent: HomeIcon,
      linkUrl: "/home",
    },
    can(DASHBOARD_PAGE_KEYS.WALLET_DASHBOARD) && {
      id: 1,
      name: "Wallet Dashboard",
      logoImage: DashboardIcon,
      linkUrl: "/home/dashboard",
    },
    can(DASHBOARD_PAGE_KEYS.ORDER_REQUEST) && {
      id: 2,
      name: "Order Request",
      logoImage: Trolley,
      linkUrl: "/home/order-requests",
    },
    can(DASHBOARD_PAGE_KEYS.LIST_PRODUCTS) && {
      id: 3,
      name: "List Products",
      logoImage: Shop,
      linkUrl: getListingAppUrl("/sellerhub"),
      isExternal: true,
    },
    can(DASHBOARD_PAGE_KEYS.WISHLIST) && {
      id: 5,
      name: "Wishlist",
      logoImage: WishlistIcon,
      linkUrl: "/home/wishlist",
    },
  ].filter(Boolean);

  const currentPath = window.location.pathname;

  const clearLocalStorageForBreadcrumb = () => {
    localStorage.removeItem("myArray");
  };

  const linkStyle = {
    textDecoration: "none",
    width: "100%",
    minWidth: "280px",
  };

  const renderItemBox = (res, isActive) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        ...SidebarStyle.SidebarItemStyle,
        background: isActive ? SIDEBAR_ACCENT : "transparent",
        color: isActive ? "#fff" : "#2c3e50",
        boxShadow: isActive ? "0 4px 12px rgba(34, 97, 162, 0.25)" : "none",

        // Home Platform: white cart normally, black cart on hover
        ...(res.invertIconWhenActive && {
          "& img": {
            filter: isActive ? "brightness(0) invert(1)" : "none",
          },
          "&:hover img": {
            filter: "brightness(0)",
          },
        }),
      }}
    >
      {res.iconComponent ? (
        <res.iconComponent
          sx={{
            fontSize: 20,
            // color: isActive ? "#fff" : "#2c3e50",
            color: "#2c3e50",
          }}
        />
      ) : (
        res.logoImage && (
          <img
            src={res.logoImage}
            width="18px"
            height="18px"
            alt=""
            title="Logo"
          />
        )
      )}

      {res.name}
    </Box>
  );

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: { xs: "10px", sm: "12px", md: "14px" },
        width: "100%",
        mt: { xs: "8px", sm: "12px", md: "16px" },
        pt: 0,
        pb: 1,
        bgcolor: "transparent",
      }}
      elevation={0}
    >
      {RouteArray.map((res) =>
        res.isExternal ? (
          <a
            key={res.id}
            href={res.linkUrl}
            onClick={(e) => {
              // SECURITY (VAPT rescan PT-25): don't navigate to a token-bearing
              // URL. Mint a single-use handoff code, then redirect.
              e.preventDefault();
              sendData(false);
              clearLocalStorageForBreadcrumb();
              goToListingApp();
            }}
            style={linkStyle}
            rel="noopener noreferrer"
          >
            {renderItemBox(res, false)}
          </a>
        ) : (
          <Link
            key={res.id}
            to={res.linkUrl}
            onClick={() => {
              sendData(false);
              clearLocalStorageForBreadcrumb();
            }}
            style={linkStyle}
          >
            {renderItemBox(
              res,
              currentPath === res.linkUrl ||
                (res.linkUrl === "/home/order-requests" &&
                  currentPath.startsWith("/home/order-request")) ||
                (res.linkUrl === "/home/wishlist" &&
                  currentPath.startsWith("/home/wishlist")) ||
                (res.linkUrl === "/home/bulk-purchase" &&
                  currentPath.startsWith("/home/bulk-purchase")),
            )}
          </Link>
        ),
      )}
    </Paper>
  );
};

export default UnifiedSidebarRoutes;
